<template>
    <div>
        <d-modal
            v-cloak
            name="paymentsShedule"
            size="shedule"
            popup-title="График платежей"
            class="d-modal_redesign d-modal_redesign_mh-856"
            id="mortgagePayments"
            @open="getPaymentsCalculations"
            @close="finishCalculate"
        >
            <div class="mortgage-payments__wrapper _dflex-block _justify-content-between _mt-40-0">
                <div>
                    <div class="_mb-16-16 _mobile-visible">
                        <p class="p2 gray-text-light">Программа</p>
                        <p class="p1 _mt-4">{{ calculatorData.targets }}</p>
                    </div>
                    <div>
                        <p class="p2 gray-text-light">{{ calculatorData.targets }}</p>
                        <p class="p1 _mt-4">{{ calculatorData.rate | formatPercent }}</p>
                    </div>
                    <div class="_mt-16">
                        <p class="p2 gray-text-light">Срок</p>
                        <p class="p1 _mt-4">{{ periodString }}</p>
                    </div>
                    <div class="_mt-16">
                        <p class="p2 gray-text-light">Сумма</p>
                        <p class="p1 _mt-4">{{ calculatorData.loanAmount | formatMoneyToInt }}</p>
                    </div>
                    <div class="_mt-16 _mobile-visible">
                        <p class="p2 gray-text-light">Переплата</p>
                        <p class="p1 _mt-4">{{ preshedulers.length ? overpaymentCdp : overpayment | formatMoneyToInt }}</p>
                    </div>
                    <div class="_mt-16 _mobile-visible">
                        <p class="p2 gray-text-light">Налоговый вычет</p>
                        <p class="p1 _mt-4">{{ tax | formatMoneyToInt }}</p>
                    </div>
                </div>
                <div class="_mobile-hidden-flx">
                    <highcharts :options="chartOptions"></highcharts>
                    <div class="_ml-32 _mt-22">
                        <div class="_dflex">
                            <div class="mortgage-payments__square mortgage-payments__square_green _mr-8"></div>
                            <div>
                                <p class="p2 gray-text-light">Сумма кредита</p>
                                <p class="p1 _mt-4">{{ calculatorData.loanAmount | formatMoneyToInt }}</p>
                            </div>
                        </div>
                        <div class="_dflex _mt-16">
                            <div class="mortgage-payments__square mortgage-payments__square_grey _mr-8"></div>
                            <div>
                                <p class="p2 gray-text-light">Переплата</p>
                                <p class="p1 _mt-4">{{ preshedulers.length ? overpaymentCdp : overpayment | formatMoneyToInt }}</p>
                            </div>
                        </div>
                        <div class="_dflex _mt-16">
                            <div class="mortgage-payments__square mortgage-payments__square_rectangle _mr-8"></div>
                            <div>
                                <p class="p2 gray-text-light">Налоговый вычет</p>
                                <p class="p1 _mt-4">{{ tax | formatMoneyToInt }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mortgage-payments__wrapper _mt-32-24">
                <div class="checkbox">
                    <input v-model="repayment" type="checkbox" class="checkbox__input">
                    <label class="checkbox__label" @click="repayment = !repayment"></label>
                    <p class="text-small">Учесть досрочное погашение <hint text="Данный расчёт производится с учётом внесения досрочного погашения в день ежемесячного платежа. В процессе выплаты ипотеки вы можете выбрать любую дату досрочного платежа, исходя из этого будет сформирован фактический расчёт" /></p>
                </div>
            </div>
            <div class="mortgage-payments__wrapper mortgage-payments__repayment _mt-16" v-if="repayment">
                <div class="mortgage-list__tags">
                    <a href="#" class="mortgage-list__tags-item" :class="{ 'mortgage-list__tags-item_active' : paymentSwitcher === 'payment' }" @click.prevent="paymentSwitcher = 'payment'">Уменьшить платёж</a>
                    <a href="#" class="mortgage-list__tags-item" :class="{ 'mortgage-list__tags-item_active' : paymentSwitcher === 'period' }" @click.prevent="paymentSwitcher = 'period'">Уменьшить срок</a>
                </div>

                <div class="_dflex-block _justify-content-between _mt-32-24" v-if="preshedulers.length">
                    <p class="mortgage-payments__preshedule-par mortgage-payments__preshedule-block mortgage-payments__preshedule-block_w159">С учетом досрочного погашения</p>
                    <div class="_dblock-flex _justify-content-between _mt-0-16">
                        <p class="mortgage-payments__preshedule-par gray-text-light">{{ paymentSwitcher === 'payment' ? 'Новый платеж' : 'Платеж' }}</p>
                        <p class="mortgage-payments__preshedule-par">{{ monthlyPayment | formatMoneyToInt }}</p>
                    </div>
                    <div class="_dblock-flex _justify-content-between _mt-0-16">
                        <p class="mortgage-payments__preshedule-par gray-text-light">{{ paymentSwitcher === 'period' ? 'Новый срок' : 'Срок' }}</p>
                        <p class="mortgage-payments__preshedule-par">{{ cdpMonths }}</p>
                    </div>
                    <div class="_dblock-flex _justify-content-between _mt-0-16">
                        <p class="mortgage-payments__preshedule-par gray-text-light">Экономия</p>
                        <p class="mortgage-payments__preshedule-par">{{ saving | formatMoneyToInt }}</p>
                    </div>
                    <a href="#" class="button button_white button-mobile-wauto button_size-sm _mobile-hidden" @click.prevent="deleteAllPreshedulers">Очистить все</a>
                </div>

                <div class="_mt-32-24" v-if="preshedulers.length">
                    <div class="mortgage-payments__preshedule _mt-32-24" v-for="(presheduler, index) in preshedulers" :key="index">
                        <p class="p2 _mobile-hidden">{{ presheduler.title }}</p>
                        <div class="_dflex">
                            <div class="mortgage-payments__preshedule-block _mr-24-16">
                                <p class="mortgage-payments__preshedule-par gray-text-light">Буду вносить</p>
                                <p class="mortgage-payments__preshedule-par">{{ presheduler.contribution }}</p>
                            </div>
                            <div class="mortgage-payments__preshedule-block">
                                <p class="mortgage-payments__preshedule-par gray-text-light">Платеж</p>
                                <p class="mortgage-payments__preshedule-par">{{ presheduler.summ | formatMoneyToInt }}</p>
                            </div>
                        </div>
                        <div class="mortgage-payments__preshedule-trash" @click="deletePresheduler(index)"></div>
                    </div>
                </div>

                <p class="p1 gray-text-light _mt-24" v-if="presheduleCounter === presheduleMaxCounter">Вы можете добавить не более 3-х платежей частично-досрочного погашения</p>

                <div class="_dflex-block _mt-32-24" v-if="presheduleCounter < presheduleMaxCounter">
                    <div class="_w-280 _mr-32-0">
                        <d-select
                            :items="[
                                { 'const': 'Разово', title: 'Разово' },
                                { 'const': 'Раз в месяц', title: 'Раз в месяц' },
                                { 'const': 'Раз в квартал', title: 'Раз в квартал' },
                                { 'const': 'Раз в полгода', title: 'Раз в полгода' },
                                { 'const': 'Раз в год', title: 'Раз в год' }
                            ]"
                            label="Буду вносить"
                            v-model="contribution"
                            :key="render"
                        />
                    </div>
                    <div class="form__item _w-280 _mr-32-0 _mt-0-16">
                        <div>
                            <input
                                placeholder="Сумма"
                                v-model.lazy="summ"
                                inputmode="numeric"
                                v-mask-numeric
                                v-money
                                class="d-input"
                                @blur="checkSumm"
                            >
                        </div>
                    </div>
                    <a target="_blank" href="#" class="button button_black _mt-0-16" @click.prevent="addPresheduler">Добавить</a>
                </div>
            </div>

            <div class="mortgage-payments__wrapper mortgage-payments__table">
                <div class="mortgage-payments__table-top" id="paymentsTop">
                    <div class="mortgage-payments__table-cell mortgage-payments__table-cell_gray mortgage-payments__table-cell-first">Месяц<div class="mortgage-payments__table-cell-rightbr"></div></div>
                    <div class="mortgage-payments__table-cell mortgage-payments__table-cell_gray mortgage-payments__table-cell-second">Платеж<div class="mortgage-payments__table-cell-rightbr"></div></div>
                    <div class="mortgage-payments__table-cell mortgage-payments__table-cell_gray mortgage-payments__table-cell-second">Проценты<div class="mortgage-payments__table-cell-rightbr"></div></div>
                    <div class="mortgage-payments__table-cell mortgage-payments__table-cell_gray mortgage-payments__table-cell-second">Основной долг<div class="mortgage-payments__table-cell-rightbr"></div></div>
                    <div class="mortgage-payments__table-cell mortgage-payments__table-cell_gray mortgage-payments__table-cell-second">Остаток долга</div>
                </div>

                <div v-for="(year, index) in payments" :key="index">
                    <div class="mortgage-payments__table-year" v-if="year.data.months.length">{{year.year}} г.</div>
                    <div class="mortgage-payments__table-main" v-if="year.data.months.length">
                        <div class="mortgage-payments__table-main-string"
                            :class="{'_mobile-hidden-flx': month.monthlyPay === ''}"
                            v-for="(month, index) in year.data.months"
                            :key="index"
                        >
                            <div class="mortgage-payments__table-cell mortgage-payments__table-cell-first mortgage-payments__table-cell-first_hauto _mobile-hidden-flx">{{month.month}}</div>
                            <div class="mortgage-payments__table-cell mortgage-payments__table-cell-first mortgage-payments__table-cell-first_hauto _mobile-visible-flx"><div>{{setMobileMonth(month.month)}}</div></div>
                            <div class="mortgage-payments__table-cell mortgage-payments__table-cell-second">{{month.monthlyPay | formatMoney}}</div>
                            <div class="mortgage-payments__table-cell mortgage-payments__table-cell-second"><span v-if="month.ratePart !== ''">{{month.ratePart | formatMoney}}</span><span v-else></span></div>
                            <div class="mortgage-payments__table-cell mortgage-payments__table-cell-second"><span v-if="month.mainDebt !== ''">{{month.mainDebt | formatMoney}}</span><span v-else></span></div>
                            <div class="mortgage-payments__table-cell mortgage-payments__table-cell-second">{{month.remainingDebt | formatMoney}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="mortgage-payments__wrapper mortgage-payments__footer">
                <div class="mortgage-payments__footer-main">
                    <div class="mortgage-payments__footer-text">Предложение носит информационный характер и не является публичной офертой. Точный расчет кредита и график платежей будет рассчитан на этапе оформления сделки </div>
                </div>
            </div> -->
            <div slot="buttons">
                <div class="_border _dflex _justify-content-between _pt-16">
                    <div class="button button_green button_size-md_icon" @click="downloadPayments"><span class="ico ico-download ico_color_white ico_size_24 _mr-8"></span> Скачать график платежей</div>
                    <div class="p3 text-gray _w-480 _mobile-hidden">Предложение носит информационный характер и не является публичной офертой. Точный расчет кредита и график платежей будет рассчитан на этапе оформления сделки</div>
                </div>
            </div>

            <!-- для скачивания графика платежей -->
            <modal-with-yandex-captcha
                v-if="modalSmsShow"
                only-request
            />
        </d-modal>
        <d-modal
			v-cloak
			name="error-modal"
			:popup-title="errorTitle"
			size="small"
		>
			<p
                class="d-modal__text p1"
                v-html="errorText"
            />
		</d-modal>
    </div>
</template>

<script>
import Highcharts from "highcharts";
import patternFillInit from "highcharts/modules/pattern-fill";
import { stringToFloat } from "../../assets/js/utils"
import { Chart } from 'highcharts-vue'
import filters, { formatPercent, formatMoneyToInt, } from '../../assets/js/vue/filters';
import dayjs from 'dayjs'
import axios from 'axios'
import DModal from '../../components/dModal.vue';
import Hint from '../../components/Hint.vue';
import ModalWithYandexCaptcha from '../../components/form/ModalWithYandexCaptcha.vue';

patternFillInit(Highcharts);

export default {
    name: "MortgageCalculatorPayments",
    data() {
        return {
            sessid: window.config.bitrix_sessid,
            modalSmsShow: true,
            errorTitle: 'Ошибка',
            errorText: 'Повторите попытку позже.',
            filters: filters,
            scrollContainer: null,
            periodString: '',
            overpayment: null,
            overpaymentCdp: null,
            saving: null,
            tax: null,
            repayment: false,
            paymentSwitcher: 'payment',
            contribution: '',
            summ: '',
            paymentAmount: '',
            paymentAmountCommon: '',
            presheduleCounter: 0,
            presheduleMaxCounter: 3,
            preshedulers: [],
            render: 0,
            payments: [],
            oldPayments: [],
            monthlyPayment: '',
            cdpMonths: '',
            info: {
                monthlyPaymentRate: 0, // Ежемесячная процентная ставка
                remainingDebt: 0, // Остаток долга
                ratePart: 0, // Процентная часть
                mainDebt: 0, // Основной долг
                tableInterval: null,
                calculationsFinish: false
            },
            chartOptions: {
                    chart: {
                        type: 'pie',
                        width: 220,
                        height: 220,
                        className: 'mortgage-payments__chart',
                        margin: 0,
                    },
                    title: {
                        text: null,
                        useHTML: true,
                        align: 'center',
                        verticalAlign: 'middle',
                    },
                    credits: {
                        enabled: false,
                    },
                    tooltip: {
                        enabled: false
                    },
                    plotOptions: {
                        pie: {
                            dataLabels: {
                                enabled: false
                            },
                            borderWidth: 0
                        },
                        series: {
                            states: {
                                hover: {
                                    halo:{
                                        size: 0,
                                    }
                                }
                            }
                        }
                    },
                    series: [{
                        minPointSize: 10,
                        innerSize: '80%',
                        zMin: 0,
                        name: 'countries',
                        data: [{
                            y: 20,
                            color: '#82BF00',
                            selected: true
                        }, {
                            y: 60,
                            color: '#EFEFEF',
                            selected: true
                        }, {
                            y: 20,
                            color: {
                                patternIndex: 0,
                            },
                            selected: true
                        }
                        ]
                    }]
            },
        }
    },
    components: {
        highcharts: Chart,
        DModal,
        Hint,
        ModalWithYandexCaptcha,
    },
    props: {
        calculatorData: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    methods: {
        getPaymentsCalculations() {
            this.periodString = this.calculatePeriod(this.$props.calculatorData.period);
            this.calculateOverpayment();
            this.calculateTaxDeduction();
            this.calculateChart();
            this.getPayments();
        },
        calculatePeriod(period) {
            let years = Math.floor(period / 12);
            let months = period % 12 > 0 ? period % 12 : '';
            let monthsDescription = months === '' ? '' : months === 1 ? 'месяц' : [2, 3, 4].includes(months) ? 'месяца' : 'месяцев';
            return `${this.filters.periodString(years)} ${months} ${monthsDescription}`;
        },
        calculateOverpayment() {
            this.overpayment = Math.round((Math.round(this.$props.calculatorData.monthlyPay) * (this.$props.calculatorData.period - 2)) - this.$props.calculatorData.loanAmount);
        },
        calculateTaxDeduction() {
            let realtyTax = this.$props.calculatorData.loanAmount < 2000000 ? Math.round(this.$props.calculatorData.loanAmount * 0.13) : 260000;
            let realtyTaxPercents = !this.preshedulers.length
                                    ? Math.round(((Math.round(this.$props.calculatorData.monthlyPay) * this.$props.calculatorData.period) - this.$props.calculatorData.loanAmount) * 0.13)
                                    : Math.round(this.overpaymentCdp * 0.13);
            if (realtyTaxPercents > 3000000) { realtyTaxPercents = 390000 }
            this.tax = realtyTax + realtyTaxPercents;
        },
        calculateChart() {
            if (this.$props.calculatorData.loanAmount) {
                let overpayment = this.preshedulers.length ? Number(this.overpaymentCdp) : this.overpayment;
                let chartCommon = Math.floor(this.$props.calculatorData.loanAmount + overpayment + this.tax);
                let loanChartPoint = this.$props.calculatorData.loanAmount / chartCommon * 100;
                let overpaymentChartPoint = overpayment / chartCommon * 100;
                let taxChartPoint = this.tax / chartCommon * 100;
                this.chartOptions.series[0].data[0].y = loanChartPoint;
                this.chartOptions.series[0].data[1].y = overpaymentChartPoint;
                this.chartOptions.series[0].data[2].y = taxChartPoint;
            }
        },
        checkSumm() {
            if (this.summ === '0' || this.summ > this.info.remainingDebt) { this.summ = '' }
        },
        getSaving() {
            this.saving = this.overpayment - this.overpaymentCdp;
        },
        addPresheduler() {
            if (this.contribution && this.summ > 0 && this.presheduleCounter <= this.presheduleMaxCounter) {
                this.presheduleCounter++;
                this.preshedulers.push({ id: this.presheduleCounter, title: `Досрочное погашение ${this.presheduleCounter}`, contribution: this.contribution, summ: this.summ });
                this.paymentAmount = this.summ;
                this.summ = '';
                this.addCdkToShedule();
                this.updatePayments();
            }
        },
        deletePresheduler(index) {
            this.presheduleCounter--;
            this.preshedulers = this.preshedulers.filter(val => val.id !== index + 1);
            this.redrawPresheduler();
            this.deleteCdkFromShedule();

            if (!this.preshedulers.length) {
                this.getPayments();
                this.calculateTaxDeduction();
                this.calculateChart();
            }
            else {
                this.updatePayments();
            }
        },
        redrawPresheduler() {
            this.preshedulers.forEach((element, index) => {
                element.id = index + 1;
                element.title = `Досрочное погашение ${index + 1}`
            })
        },
        deleteAllPreshedulers() {
            this.presheduleCounter = 0;
            this.preshedulers = [];
            this.deleteCdkFromShedule();

            if (!this.preshedulers.length) {
                this.getPayments();
                this.calculateTaxDeduction();
                this.calculateChart();
            }
            else {
                this.updatePayments();
            }
        },
        getPayments() {
            this.info.monthlyPaymentRate = this.info.mainPaymentRate = this.info.remainingDebt = this.info.ratePart = this.info.mainDebt = 0;
            const currentYear = Number(dayjs().format('YYYY'));
            const currentMonth = dayjs().month();
            const months = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
            this.info.monthlyPaymentRate = this.getMonthlyPaymentRate();
            this.payments = [];

            for (let i=0; i < Math.round(this.$props.calculatorData.period / 12) + 1; i++) {
                let calculations = [];
                months.forEach((val, index) => {
                    // Для первого года

                    if (i === 0 && index > currentMonth) {
                        const allData =  this.getCalculations(`${val} ${currentYear + i}`);
                        calculations.push(allData);
                    }
                    // Для последующих годов
                    else if (i !== 0 && i !== (this.$props.calculatorData.period / 12)) {
                        const allData = this.getCalculations(`${val} ${currentYear + i}`);
                        if (this.info.remainingDebt === 0) {
                            calculations.push(allData)
                            this.calculationsFinish = true;
                        }
                        if (!this.calculationsFinish) { calculations.push(allData) }
                    }
                    // Для последнего года
                    else if (i !== 0 && i === (this.$props.calculatorData.period / 12)) {
                        const allData = this.getCalculations(`${val} ${currentYear + i}`);
                        if (this.info.remainingDebt === 0) {
                            calculations.push(allData)
                            this.calculationsFinish = true;
                        }

                        if (!this.calculationsFinish) calculations.push(allData);
                    }
                })

                if (calculations.length) this.payments[this.payments.length] = { year:currentYear + i, data:{months:calculations} }
            }
        },
        getCalculations(month) {
            this.info.ratePart = this.info.remainingDebt === 0 ? this.$props.calculatorData.loanAmount * this.info.monthlyPaymentRate : this.info.remainingDebt * this.info.monthlyPaymentRate;
            this.info.mainDebt = this.$props.calculatorData.monthlyPay - this.info.ratePart;
            this.info.remainingDebt = this.info.remainingDebt === 0 ? this.$props.calculatorData.loanAmount - this.info.mainDebt : this.info.remainingDebt - this.info.mainDebt;
            if (this.info.remainingDebt < 100) { this.info.remainingDebt = 0 }
            return { month: month, monthlyPay: this.$props.calculatorData.monthlyPay.toFixed(2), ratePart: this.info.ratePart.toFixed(2), mainDebt: this.info.mainDebt.toFixed(2), remainingDebt: this.info.remainingDebt.toFixed(2) };
        },
        getMonthlyPaymentRate() {
            return +((this.$props.calculatorData.rate / 12 / 100).toFixed(7));
        },
        addCdkToShedule(flag) {
            let repeatPresheduler = false;
            this.payments.forEach((element, index) => {
                let newMonths = [];
                element.data.months.forEach((el, ind) => {
                    repeatPresheduler = false;
                    let trueIndex = this.getTrueIndex(element.data.months, ind);
                    if (element.data.months[ind + 1]?.month === 'Досрочное погашение') {
                        element.data.months[ind + 1].monthlyPay = this.getPreshedulerSumm(index, trueIndex, element.data.months[ind + 1].monthlyPay, flag);
                        element.data.months[ind + 1].remainingDebt = Number(el.remainingDebt) - Number(element.data.months[ind + 1].monthlyPay);
                        repeatPresheduler = true;
                    }
                    if (element.data.months[ind - 1]?.month === 'Досрочное погашение') {
                        if (Number(newMonths[ind]?.monthlyPay) !== Number(this.paymentAmountCommon)) newMonths.splice(ind, 1);
                    }
                    if (
                        element.data.months.length === ind + 1 && el.month === 'Досрочное погашение' ||
                        Number(el.remainingDebt) < 100
                    ) {
                        repeatPresheduler = true;
                    }

                    newMonths.push(el);
                    if (this.preshedulers.length && this.contribution === 'Разово') {
                        if (index === 0 && ind === 0 && !repeatPresheduler) {
                            newMonths.push({ month: 'Досрочное погашение', monthlyPay: this.paymentAmount, ratePart: '', mainDebt: '', remainingDebt: (Number(el.remainingDebt) - Number(this.paymentAmount)).toString() })
                        }
                    }
                    else if (this.preshedulers.length && this.contribution === 'Раз в месяц') {
                       if (Number(el.remainingDebt) !== 0 && !repeatPresheduler) {
                            newMonths.push({ month: 'Досрочное погашение', monthlyPay: this.paymentAmount, ratePart: '', mainDebt: '', remainingDebt: (Number(el.remainingDebt) - Number(this.paymentAmount)).toString() })
                       }
                    }
                    else if (this.preshedulers.length && this.contribution === 'Раз в квартал') {
                        if ([0, 3, 6, 9].includes(trueIndex) && !repeatPresheduler) {
                            newMonths.push({ month: 'Досрочное погашение', monthlyPay: this.paymentAmount, ratePart: '', mainDebt: '', remainingDebt: (Number(el.remainingDebt) - Number(this.paymentAmount)).toString() });
                        }
                    }
                    else if (this.preshedulers.length && this.contribution === 'Раз в полгода') {
                        if ([0, 6].includes(trueIndex) && !repeatPresheduler) {
                            newMonths.push({ month: 'Досрочное погашение', monthlyPay: this.paymentAmount, ratePart: '', mainDebt: '', remainingDebt: (Number(el.remainingDebt) - Number(this.paymentAmount)).toString() })
                        }
                    }
                    else if (this.preshedulers.length && this.contribution === 'Раз в год') {
                        if (ind === 0 && !repeatPresheduler) {
                            newMonths.push({ month: 'Досрочное погашение', monthlyPay: this.paymentAmount, ratePart: '', mainDebt: '', remainingDebt: (Number(el.remainingDebt) - Number(this.paymentAmount)).toString() })
                        }
                    }
                })
                element.data.months = newMonths;
            })
        },
        getTrueIndex(elements, index) {
            let elementsCounter = 0, trueIndex = 0;
            elements.forEach((el, ind) => {
                if (el.month !== 'Досрочное погашение' && ind !== 0) elementsCounter++
                if (elements[index].month === elements[ind].month) {
                   trueIndex = elementsCounter;
                }
            })
            return trueIndex;
        },
        deleteCdkFromShedule() {
            if (this.preshedulers.length) {
                this.preshedulers.forEach(el => {
                    this.paymentAmount = el.summ;
                    this.contribution = el.contribution;
                })
            }
            else {
                this.paymentAmount = this.contribution = '';
            }
            this.addCdkToShedule('del');
        },
        getPreshedulerSumm(commonIndex, localIndex, element, flag) {
            if (
                this.contribution === 'Разово' && commonIndex === 0 && localIndex === 0 ||
                this.contribution === 'Раз в месяц' ||
                this.contribution === 'Раз в квартал' && [0, 3, 6, 9].includes(localIndex) ||
                this.contribution === 'Раз в полгода' && [0, 6].includes(localIndex) ||
                this.contribution === 'Раз в год' && localIndex === 0
            )
            {
                element = flag === 'del'
                        ? this.paymentAmountCommon = (Number(element) - Number(this.paymentAmount)).toString()
                        : this.paymentAmountCommon = (Number(element) + Number(this.paymentAmount)).toString();
            }
            return element;
        },
        updatePayments() {
            let finish = false;
            let remainingDebt = 0, remainingMonths = 0, newMonthlyPay = 0, lastIndex = 0, finishYear = 0, percentsSum = 0;
            this.payments.forEach((element, index) => {
                element.data.months.forEach((el, ind) => {
                    if (index === 0 && ind === 0) {
                        remainingMonths = this.$props.calculatorData.period - 1;
                        remainingDebt = el.remainingDebt;
                        percentsSum += Number(el.ratePart);
                    }
                    else {
                        if (!finish) {
                            // Обновляем остаток долга для месяца с досрочным погашением
                            if (el.month !== 'Досрочное погашение') remainingMonths--
                            if (el.month === 'Досрочное погашение') {
                                remainingDebt = Number(remainingDebt) - Number(el.monthlyPay);
                                el.remainingDebt = remainingDebt > 0 ? remainingDebt : 0;
                            }
                            // Обновляем месячный платеж
                            if (el.month === 'Досрочное погашение') {
                                if (this.paymentSwitcher === 'payment') {
                                    newMonthlyPay = Math.floor((Number(remainingDebt) * (this.$props.calculatorData.rate / 1200)) / (1-(Math.pow(1+this.info.monthlyPaymentRate, (2-remainingMonths)))));
                                }
                                else {
                                    newMonthlyPay = this.$props.calculatorData.monthlyPay.toFixed(2);
                                }
                            }
                            if (el.month !== 'Досрочное погашение') el.monthlyPay = newMonthlyPay
                            // Обновляем проценты
                            if (el.month !== 'Досрочное погашение') {
                                el.ratePart = (remainingDebt * this.info.monthlyPaymentRate).toFixed(2);
                                percentsSum += Number(el.ratePart);
                            }
                            // Обновляем основной долг
                            if (el.month !== 'Досрочное погашение') {
                                el.mainDebt = this.paymentSwitcher === 'payment' ? newMonthlyPay - el.ratePart : el.monthlyPay - el.ratePart;
                            }
                            // Обновляем остаток долга для обычного месяца
                            if (el.month !== 'Досрочное погашение') {
                                remainingDebt = el.remainingDebt = (Number(remainingDebt) - Number(el.monthlyPay)) + Number(el.ratePart);
                            }
                            // Заканчиваем обновление
                            if (el.remainingDebt < 1000) {
                                el.remainingDebt = 0;
                                finish = true;
                                finishYear = element.year;
                                lastIndex = ind;
                                this.cdpMonths = this.calculatePeriod(this.$props.calculatorData.period - remainingMonths);
                            }
                            // Выносим новый платеж для строки
                            if (index === 0 && ind === 2) {
                                this.monthlyPayment = el.monthlyPay;
                            }
                        }
                        else {
                            element.data.months = element.data.months.filter((val, i) => {
                                if (i <= lastIndex) return val.month
                            })
                        }
                    }
                })
                if (finish) {
                    this.payments = this.payments.filter(val => val.year <= finishYear);
                    this.overpaymentCdp = percentsSum.toFixed();
                    this.getSaving();
                    this.calculateTaxDeduction();
                    this.calculateChart();
                }
            })
            if (this.paymentSwitcher === 'payment') this.oldPayments = JSON.parse(JSON.stringify(this.payments))
        },
        setMobileMonth(month) {
            return month.substring(0, 3);
        },
        finishCalculate() {
            this.deleteAllPreshedulers();
            this.calculationsFinish = false;
            this.repayment = false;
        },
        // объект плетежей для запроса
        paymentsForRequest() {
            let payments = [];
            let summary = {
                month: 'Итого',
                payment: 0,
                ratePart: 0,
                mainDebt: 0,
                principalBalance: null
            };

            this.payments.forEach(pay => {
                pay.data.months.forEach(month => {
                    payments.push({
                        month: month.month,
                        payment: month.monthlyPay,
                        ratePart: month.ratePart,
                        mainDebt: month.mainDebt,
                        principalBalance: month.remainingDebt,
                    })

                    summary.payment += stringToFloat(String(month.monthlyPay).replace(/\s/g, ''));
                    summary.ratePart += stringToFloat(String(month.ratePart).replace(/\s/g, ''));
                    summary.mainDebt += stringToFloat(String(month.mainDebt).replace(/\s/g, ''));
                })
            })
            summary.payment = summary.payment.toFixed(2);
            summary.ratePart = summary.ratePart.toFixed(2);
            summary.mainDebt = summary.mainDebt.toFixed(2);

            payments.push(summary);

            return payments;
        },
        // создание ссылки для скачивания и последующее её удаление
        downloadFile(data) {
            const url = URL.createObjectURL(data);
            const a = document.createElement('a');
            a.download = 'payments.pdf';
            a.href = url;
            a.target = '_self';

            a.click();

            setTimeout(function () {
                a.remove();
                URL.revokeObjectURL(url);
            }, 100);
        },
        // получение срока после досрочного погашения с уменьшением срока
        getDecreasedTerm() {
            let years = parseInt(this.cdpMonths.split(' лет')[0] * 12);
            let months = 0;
            if (this.cdpMonths.split(' лет')[1]) {
                months = parseInt(this.cdpMonths.split(' лет')[1].replace(/\D/g, ''));
            }
            return years + months
        },
        // запрос на скачивание файла
        downloadPayments() {
            let data = {
                data: {
                    type: "paymentScheduleDownload",
                    attributes: {
                        info: {
                            program: this.calculatorData.targets,
                            rate: this.calculatorData.rate,
                            term: (this.paymentSwitcher == 'period' && this.preshedulers.length) ? this.getDecreasedTerm() : this.calculatorData.period,
                            amount: this.calculatorData.loanAmount
                        },
                        items: this.paymentsForRequest()
                    }
                }
            }
            this.$parent.loading = true;
            axios.post('/rest/v1/mortgage/calculator/paymentSchedule/download?sessid=' + this.sessid, data, {responseType: 'blob'})
                .then(res => {
                    this.downloadFile(res.data);
                })
                .catch(res => {
                    if (res.response.status === 500) {
                        this.errorTitle = 'Ошибка';
                        this.errorText = 'Повторите попытку позже.';
                    }
                    if (res.response.status === 422) {
                        this.errorTitle = 'Ошибка';
                        this.errorText = 'Неверные данные. Повторите попытку позже.';
                    }

                    this.$modal.show('error-modal')
                })
                .finally(() => {
                    this.$parent.loading = false;
                })
        }
    },
    filters: {
        formatPercent,
        formatMoneyToInt,
    },
    watch: {
        preshedulers() {
            this.calculationsFinish = false;
        },
        presheduleCounter(val) {
            this.render = val;
        },
        paymentSwitcher() {
            if (this.oldPayments.length) {
                this.payments = JSON.parse(JSON.stringify(this.oldPayments));
                this.updatePayments();
            }
        },
        repayment(val) {
            if (!val) {
                this.deleteAllPreshedulers();
            }
        }
    }
}
</script>
<style lang="scss">
@import '/local/templates/redesign/src/assets/scss/pages/mortgage/mortgage-payments.scss';
</style>
